import { TextValue } from '@shared/types';
import { TimezoneHelper } from './timezone.helper';

function convertDateToString(date: Date) {
    const month: number = date.getMonth() + 1;
    return `${date.getFullYear()}/${month}/${date.getDate()}`;
}

function convertToNumberArray(input: any | any[]): number[] {
    if (!input) {
        return [];
    }
    if (Array.isArray(input)) {
        return input.map(inputValue => {
            return parseInt(inputValue);
        });
    }
    return [parseInt(input)];
}

function computeDateRange(dateRange: Date[]): { startDate: Date | null; endDate: Date | null } {
    const startDate = dateRange[0];
    const endDate = dateRange[1];

    return {
        startDate: startDate ? TimezoneHelper.startOfDay(startDate) : null,
        endDate: endDate ? TimezoneHelper.endOfDay(endDate) : null,
    };
}

function trimStrings(obj: any): any {
    if (typeof obj === 'string') {
        return obj.trim();
    } else if (typeof obj === 'object' && obj !== null) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                obj[key] = GeneralHelper.trimStrings(obj[key]);
            }
        }
    }
    return obj;
}

function isTextValueArray(arr: TextValue[] | number[]): arr is TextValue[] {
    return arr.length > 0 && typeof arr[0] === 'object' && 'text' in arr[0];
}

function isExternalLink(name: string): boolean {
    return (
        name.startsWith('http://') ||
        name.startsWith('https://') ||
        name.startsWith('ftp://') ||
        name.startsWith('sftp://') ||
        name.startsWith('www.')
    );
}

export const GeneralHelper = {
    convertDateToString,
    convertToNumberArray,
    computeDateRange,
    trimStrings,
    isExternalLink,
    isTextValueArray,
};
